// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

/* selfie css */
.selfie {
  display: flex;
  justify-content: center;
}

.cam,
.preview {
  position: relative;
}

.preview-img {
  display: block;
}

.capture-btn {
  position: absolute;
  bottom: 9px;
  display: block;
  left: 50%;
  transform: translateX(-50%);
  background: none;
  color: #fff;
  border: none;
  font-size: 40px;
}

.video-player {
  display: block;
}

.btn-container {
  display: flex;
  justify-content: space-between;
  position: absolute;
  bottom: 0;
  left: 0;
}

.back-btn,
.download-btn {
  background: none;
  color: #fff;
  border: none;
  font-size: 40px;
}

.download-btn {
  margin-left: 25px;
}

/* demo image preview */
.demo-image-preview {
  position: relative;
  text-align: center;
}

.demo-image-preview>img {
  width: 768px;
}

/* change padding of checkboxes in filter panel to make them compact */
div[class*="filterSidebarWrappper"] .MuiCheckbox-root {
  padding: 5px !important
}

/* change padding top of variant type filled autocomplete boxes */
.MuiAutocomplete-inputRoot[class*="MuiFilledInput-root"] {
  padding-top: 8px!important;
}

@media(max-width:768px) {
  .demo-image-preview>img {
    width: 100%;
  }
}

/* fullscreen enable by props */
.demo-image-preview-fullscreen>img {
  width: 100vw;
  height: 100vh;
}`, "",{"version":3,"sources":["webpack://./src/style/App.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,SAAS;EACT,OAAO;AACT;;AAEA;;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA,sEAAsE;AACtE;EACE;AACF;;AAEA,iEAAiE;AACjE;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA,+BAA+B;AAC/B;EACE,YAAY;EACZ,aAAa;AACf","sourcesContent":[".flex-center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* selfie css */\n.selfie {\n  display: flex;\n  justify-content: center;\n}\n\n.cam,\n.preview {\n  position: relative;\n}\n\n.preview-img {\n  display: block;\n}\n\n.capture-btn {\n  position: absolute;\n  bottom: 9px;\n  display: block;\n  left: 50%;\n  transform: translateX(-50%);\n  background: none;\n  color: #fff;\n  border: none;\n  font-size: 40px;\n}\n\n.video-player {\n  display: block;\n}\n\n.btn-container {\n  display: flex;\n  justify-content: space-between;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n}\n\n.back-btn,\n.download-btn {\n  background: none;\n  color: #fff;\n  border: none;\n  font-size: 40px;\n}\n\n.download-btn {\n  margin-left: 25px;\n}\n\n/* demo image preview */\n.demo-image-preview {\n  position: relative;\n  text-align: center;\n}\n\n.demo-image-preview>img {\n  width: 768px;\n}\n\n/* change padding of checkboxes in filter panel to make them compact */\ndiv[class*=\"filterSidebarWrappper\"] .MuiCheckbox-root {\n  padding: 5px !important\n}\n\n/* change padding top of variant type filled autocomplete boxes */\n.MuiAutocomplete-inputRoot[class*=\"MuiFilledInput-root\"] {\n  padding-top: 8px!important;\n}\n\n@media(max-width:768px) {\n  .demo-image-preview>img {\n    width: 100%;\n  }\n}\n\n/* fullscreen enable by props */\n.demo-image-preview-fullscreen>img {\n  width: 100vw;\n  height: 100vh;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
